import 'ol/ol.css';
import {fromLonLat} from 'ol/proj';
import {Map, View} from 'ol';
import {Vector as VectorLayer} from 'ol/layer';
import {Cluster, Vector as VectorSource} from 'ol/source';

import {Icon, Circle as CircleStyle, RegularShape, Fill, Stroke, Style, Text} from 'ol/style.js';

import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';


//vector of ships start
const source = new VectorSource();

const client = new XMLHttpRequest();

if (screen.width <= 800) {
client.open('GET', 'xml/26_06_26nameodd.csv');
//console.log('odd');
}
else{
client.open('GET', 'xml/26_06_26name.csv');
//console.log('even');
};


client.onload = function() {
  const csv = client.responseText;
  const features = [];

  let prevIndex = csv.indexOf('\n') + 1; // scan past the header line

  let curIndex;
  while ((curIndex = csv.indexOf('\n', prevIndex)) != -1) {
    const line = csv.substr(prevIndex, curIndex - prevIndex).split(',');
    prevIndex = curIndex + 1;

    const coords = fromLonLat([parseFloat(line[1]), parseFloat(line[0])]);
    if (isNaN(coords[0]) || isNaN(coords[1])) {
      // guard against bad data
      continue;
    }

    features.push(new Feature({
     name: (line[2]) || 0,
      //length: parseFloat(line[6]) || 0,
      type: parseInt(line[3]) || 0,
      //heading: parseInt(line[4]) || 0,
      //speed: parseInt(line[5]) || 0,
      geometry: new Point(coords),
      anchor: [ 0, 0 ]
    }));
  }
  source.addFeatures(features);
};
client.send();

/* 
const elevation = new XYZSource({
  url: 'https://server.arcgisonline.com/ArcGIS/rest/services/' +
                  'Ocean/World_Ocean_Base/MapServer/tile/{z}/{y}/{x}',
  crossOrigin: 'anonymous'
});


//! [flood]
function flood(pixels, data) {
  const pixel = pixels[0];
  if (pixel[3]) {

      pixel[0] =  pixel[0]; // red
      pixel[1] =  pixel[1];  // green
      pixel[2] =  pixel[2]*pixel[2];  // blue
      pixel[3] =  255; // alpha
        return pixel;
  }
  return pixel;
}
//! [flood]

//! [raster]
const raster = new RasterSource({
  sources: [elevation],
  operation: flood
});
 */
//! [raster]
/////extra maps
/* 
const opensea = new XYZSource({
     url: 'https://t1.openseamap.org/seamark/{z}/{x}/{y}.png',
  });

/// Esri ocean depths
/* 
const ocean2 = new XYZSource({
              url: 'https://server.arcgisonline.com/ArcGIS/rest/services/' +
                  'Ocean/World_Ocean_Base/MapServer/tile/{z}/{y}/{x}'
            });
            
 */
            
//////iconcluster            

//var styleCache = {};
const getIconStyle = function(feature) {

var cfeatures = feature.get('features');

  if(cfeatures.length > 1) {
     //cluster
      var size = feature.get('features').length;
     var rand = Math.floor(Math.random() * (size-1));
     //console.log(rand+1);

	var type =cfeatures[rand+1].get('type');
	var name =cfeatures[rand+1].get('name');
	//console.log(name);
   //console.log(cfeatures[1].get('name'));
// var size = feature.get('features').length;


         // var style = styleCache[size];
         // if (!style) {

if (type==0){// Manned vts
var style = new Style({
			text: new Text({
                text: name.toString(),
                fill: new Fill({
                  color: '#888888'
                }),
                backgroundFill:new Fill({
                  color: '#cccccc'
                }),
                padding:[2,2,2,2]
              })})
}  
else if  (type==1){// Navigations Aids
var style = new Style({
              text: new Text({
                text: name.toString(),
                fill: new Fill({
                  color: '#888888'
                }),
                backgroundFill:new Fill({
                  color: '#ff9966'
                }),
                padding:[2,2,2,2]
              })})
}   
else  if (type==3){// Tug, Pilot, etc.
var style = new Style({
              text: new Text({
                text: name.toString(),
                fill: new Fill({
                  color: '#888888'
                }),
                backgroundFill:new Fill({
                  color: '#00ffff'
                }),
                padding:[2,2,2,2]
              })})
}  
else  if (type==4){// High Speed Craft
var style = new Style({
              text: new Text({
                text: name.toString(),
                fill: new Fill({
                  color: '#888888'
                }),
                backgroundFill:new Fill({
                  color: '#ffff00'
                }),
                padding:[2,2,2,2]
              })})
}  
else  if (type==6){// Passenger Vessel
var style = new Style({
              text: new Text({
                text: name.toString(),
                fill: new Fill({
                  color: '#888888'
                }),
                backgroundFill:new Fill({
                  color: '#0000ff'
                }),
                padding:[2,2,2,2]
              })})
}  
else  if (type==7){// Cargo Vessel
var style = new Style({
              text: new Text({
                text: name.toString(),
                fill: new Fill({
                  color: '#888888'
                }),
                backgroundFill:new Fill({
                  color: '#00ff00'
                }),
                padding:[2,2,2,2]
              })})
}  
else  if (type==8){// Tanker
var style = new Style({
              text: new Text({
                text: name.toString(),
                fill: new Fill({
                  color: '#888888'
                }),
                backgroundFill:new Fill({
                  color: '#ff0000'
                }),
                padding:[2,2,2,2]
              })})
}  
else  if (type==9){// Yacht & Other
var style = new Style({
              text: new Text({
                text: name.toString(),
                fill: new Fill({
                  color: '#888888'
                }),
                backgroundFill:new Fill({
                  color: '#ff00ff'
                }),
                padding:[2,2,2,2]
              })})
}  
else  
{
var style = new Style({
              text: new Text({
                text: name.toString(),
                fill: new Fill({
                  color: '#888888'
                }),
                backgroundFill:new Fill({
                  color: '#cccccc'
                }),
                padding:[2,2,2,2]
              })})
}       


          //  styleCache[size] = style;
         // }
          return style;
  } 
  else 
  if(cfeatures.length == 1){
     //no clusters
/* 
    var heading =cfeatures[0].get('heading');
	var angle = (heading * Math.PI) / 180;
	var speed =cfeatures[0].get('speed');
 */
	var type =cfeatures[0].get('type');
	var name =cfeatures[0].get('name');
    //console.log(cfeatures[0].get('type'));


if (type==0){// Manned vts
var style = new Style({
			text: new Text({
                text: name.toString(),
                fill: new Fill({
                  color: '#888888'
                }),
                backgroundFill:new Fill({
                  color: '#cccccc'
                }),
                padding:[2,2,2,2]
              })})
}  
else if  (type==1){// Navigations Aids
var style = new Style({
              text: new Text({
                text: name.toString(),
                fill: new Fill({
                  color: '#888888'
                }),
                backgroundFill:new Fill({
                  color: '#ff9966'
                }),
                padding:[2,2,2,2]
              })})
}   
else  if (type==3){// Tug, Pilot, etc.
var style = new Style({
              text: new Text({
                text: name.toString(),
                fill: new Fill({
                  color: '#888888'
                }),
                backgroundFill:new Fill({
                  color: '#00ffff'
                }),
                padding:[2,2,2,2]
              })})
}  
else  if (type==4){// High Speed Craft
var style = new Style({
              text: new Text({
                text: name.toString(),
                fill: new Fill({
                  color: '#888888'
                }),
                backgroundFill:new Fill({
                  color: '#ffff00'
                }),
                padding:[2,2,2,2]
              })})
}  
else  if (type==6){// Passenger Vessel
var style = new Style({
              text: new Text({
                text: name.toString(),
                fill: new Fill({
                  color: '#888888'
                }),
                backgroundFill:new Fill({
                  color: '#0000ff'
                }),
                padding:[2,2,2,2]
              })})
}  
else  if (type==7){// Cargo Vessel
var style = new Style({
              text: new Text({
                text: name.toString(),
                fill: new Fill({
                  color: '#888888'
                }),
                backgroundFill:new Fill({
                  color: '#00ff00'
                }),
                padding:[2,2,2,2]
              })})
}  
else  if (type==8){// Tanker
var style = new Style({
              text: new Text({
                text: name.toString(),
                fill: new Fill({
                  color: '#888888'
                }),
                backgroundFill:new Fill({
                  color: '#ff0000'
                }),
                padding:[2,2,2,2]
              })})
}  
else  if (type==9){// Yacht & Other
var style = new Style({
              text: new Text({
                text: name.toString(),
                fill: new Fill({
                  color: '#888888'
                }),
                backgroundFill:new Fill({
                  color: '#ff00ff'
                }),
                padding:[2,2,2,2]
              })})
}  
else  
{
var style = new Style({
              text: new Text({
                text: name.toString(),
                fill: new Fill({
                  color: '#888888'
                }),
                backgroundFill:new Fill({
                  color: '#cccccc'
                }),
                padding:[2,2,2,2]
              })})
}        
 return style;
}


}



var clusterSource = new Cluster({
        distance: 60,
        source: source
      });
      
     var clusters = new VectorLayer({
        source: clusterSource,
		style:getIconStyle
      });      
      
var fitWorldZoom = Math.max(0, Math.log(Math.max(window.innerWidth, window.innerHeight) / 256) / Math.LN2);
var zoomOutAllowance = window.innerWidth <= 800 ? 1.0 : 0.5;

var map = new Map({
  target: 'map-container',
  layers: [
/* 
  new TileLayer({
      source: ocean2,
      opacity: 0.1
    }),

    new TileLayer({
      source: opensea,
      opacity: 1.0
    }),
 */

/* 
    new ImageLayer({
      opacity: 1.0,
      source: raster
    }), 
 */


clusters

  ],
  view: new View({
    center: fromLonLat([0, 30]),
          zoom: fitWorldZoom,
          minZoom: fitWorldZoom - zoomOutAllowance,
          multiWorld: true
          //,
         // maxZoom: 10
  })
});

var mercatorWorldLimit = 20037508.342789244;
var portShownByDrag = false;
map.on('pointerdrag', function() {
  if (!portShownByDrag) {
    portShownByDrag = true;
    if (window.hidePortTimer) {
      clearTimeout(window.hidePortTimer);
      window.hidePortTimer = null;
    }
    window.display_random_image();
  }
});
map.on('moveend', function() {
  var view = map.getView();
  var center = view.getCenter();
  var y = Math.max(-mercatorWorldLimit, Math.min(mercatorWorldLimit, center[1]));

  if (y !== center[1]) {
    view.setCenter([center[0], y]);
  }

  if (portShownByDrag) {
    portShownByDrag = false;
    window.hideport();
  }
});


/**
 * Add a click handler to the map to render the popup.
 */
 


map.on('click', function(evt) {
show();
});
